import { render, staticRenderFns } from "./imprint.vue?vue&type=template&id=6a0c8a2b&scoped=true"
import script from "./imprint.vue?vue&type=script&lang=js"
export * from "./imprint.vue?vue&type=script&lang=js"
import style0 from "./imprint.vue?vue&type=style&index=0&id=6a0c8a2b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0c8a2b",
  null
  
)

export default component.exports